(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function clamp01(value) {
    return Math.min(1, Math.max(0, value));
  }

  function init() {
    toArray(document.querySelectorAll('[data-smarch-stats]')).forEach(setupSection);
  }

  function setupSection(section) {
    if (section.dataset.smarchStatsReady === '1') return;
    section.dataset.smarchStatsReady = '1';
    splitWords(section);
    setupWordReveal(section);
    setupCounters(section);
  }

  function splitWords(section) {
    var intro = section.querySelector('[data-smarch-stats-intro]');
    if (!intro) return;
    var raw = (intro.textContent || '').trim();
    if (!raw) return;

    var tokens = raw.split(/(\s+)/);
    var frag = document.createDocumentFragment();
    tokens.forEach(function (token) {
      if (!token) return;
      if (/^\s+$/.test(token)) {
        frag.appendChild(document.createTextNode(token));
        return;
      }
      var span = document.createElement('span');
      span.className = 'smarch-signature-stats__word';
      span.setAttribute('data-smarch-word', '');
      span.textContent = token;
      frag.appendChild(span);
    });
    intro.innerHTML = '';
    intro.appendChild(frag);
  }

  function setupWordReveal(section) {
    var intro = section.querySelector('[data-smarch-stats-intro]');
    if (!intro) return;
    var words = toArray(intro.querySelectorAll('[data-smarch-word]'));
    if (!words.length) return;

    var revealedCount = 0;
    var ticking = false;

    function update() {
      ticking = false;
      var rect = intro.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 1;

      // Reveal window: words begin revealing when the intro's top reaches
      // 90% of viewport height, and are fully revealed by the time it reaches 15%.
      // That maps the cascade tightly to the user's scroll motion.
      var start = vh * 0.9;
      var end = vh * 0.15;
      var distance = start - end;
      var progress = distance > 0 ? clamp01((start - rect.top) / distance) : (rect.top <= start ? 1 : 0);
      var target = Math.round(progress * words.length);

      if (target === revealedCount) return;

      if (target > revealedCount) {
        for (var i = revealedCount; i < target; i++) {
          words[i].classList.add('is-revealed');
        }
      } else {
        for (var j = revealedCount - 1; j >= target; j--) {
          words[j].classList.remove('is-revealed');
        }
      }
      revealedCount = target;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function setupCounters(section) {
    var counters = toArray(section.querySelectorAll('[data-smarch-counter]'));
    if (!counters.length) return;

    counters.forEach(function (el) {
      var raw = el.getAttribute('data-target') || el.textContent;
      var parsed = parseValue(raw);
      if (!parsed) return;
      el.smarchCounter = parsed;
      el.textContent = parsed.prefix + formatNumber(0, parsed.decimals) + parsed.suffix;
    });

    if (!('IntersectionObserver' in window)) {
      counters.forEach(function (el, index) {
        window.setTimeout(function () { animateCounter(el); }, index * 150);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var index = counters.indexOf(el);
          window.setTimeout(function () { animateCounter(el); }, Math.max(0, index) * 150);
          observer.unobserve(el);
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -10% 0px' }
    );

    counters.forEach(function (el) { observer.observe(el); });
  }

  function parseValue(text) {
    if (!text) return null;
    var match = String(text).match(/^(\D*?)(\d+(?:\.\d+)?)(.*)$/);
    if (!match) return null;
    var numStr = match[2];
    var decimals = numStr.indexOf('.') >= 0 ? numStr.split('.')[1].length : 0;
    return {
      prefix: match[1] || '',
      number: parseFloat(numStr),
      suffix: match[3] || '',
      decimals: decimals
    };
  }

  function formatNumber(value, decimals) {
    return decimals > 0 ? value.toFixed(decimals) : String(Math.round(value));
  }

  function animateCounter(el) {
    var data = el.smarchCounter || parseValue(el.getAttribute('data-target'));
    if (!data) return;
    var duration = 1800;
    var start = performance.now();

    function step(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var current = eased * data.number;
      el.textContent = data.prefix + formatNumber(current, data.decimals) + data.suffix;
      if (t < 1) window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
